import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledGroup } from '../Button/Button.styles.js';
import { BUTTON_GROUP_ALIGNMENT } from '../Button/Button.constants.js';

var ButtonGroup = function ButtonGroup(_ref) {
  var _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? BUTTON_GROUP_ALIGNMENT.HORIZONTAL : _ref$alignment,
    children = _ref.children,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  return React__default.createElement(StyledGroup, {
    $alignment: alignment,
    role: "group",
    "data-testid": testId
  }, children);
};
ButtonGroup.propTypes = {
  alignment: PropTypes.oneOf(Object.values(BUTTON_GROUP_ALIGNMENT)),
  children: PropTypes.node.isRequired,
  testId: PropTypes.string
};

export { ButtonGroup };
//# sourceMappingURL=ButtonGroup.js.map
